// extracted by mini-css-extract-plugin
module.exports = {"whereToBuy_h5":"WTB_whereToBuy_h5__NuUMV"};